import { PageHero } from "./MarketingLayout";
import EnquiryForm from "@/components/EnquiryForm";
import { Car, Wrench, Users2 } from "lucide-react";

export default function Exhibitors() {
  return (
    <div>
      <PageHero eyebrow="Show your build" title="Exhibitors"
        subtitle="Whether you are a private builder or a workshop, put your car and your brand in front of Perth's biggest custom car crowd." />
      <section className="max-w-7xl mx-auto px-6 pb-16 grid md:grid-cols-3 gap-6">
        {[
          { icon: Car, title: "Display a Car", text: "Get your build on a lit podium in front of thousands. Submit year, make, model and photos in the app." },
          { icon: Wrench, title: "Trade Stalls", text: "Stalls from 3x3 to 7x16. Sell parts, apparel and services right on the show floor." },
          { icon: Users2, title: "Massive Reach", text: "Two days, thousands of enthusiasts and full social coverage across the PAS channels." },
        ].map((b, i) => (
          <div key={i} className="border border-white/10 bg-[#121212] p-8 card-hover">
            <b.icon className="text-[#ff7a1a] mb-4" size={30} />
            <h3 className="font-heading text-xl uppercase text-white">{b.title}</h3>
            <p className="text-[#8a8d91] mt-2 font-body">{b.text}</p>
          </div>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-6 pb-24">
        <h2 className="font-display text-4xl sm:text-6xl uppercase text-white mb-6">Enquire about a stall</h2>
        <EnquiryForm testid="exhibitor-form" endpoint="/exhibitor-enquiry"
          successMsg="Exhibitor enquiry sent" fields={[
            { name: "name", label: "Full name", required: true },
            { name: "email", label: "Email", type: "email", required: true },
            { name: "phone", label: "Phone" },
            { name: "business", label: "Business or club name" },
            { name: "stall_size", label: "Preferred stall size", type: "select", options: ["3x3", "4x6", "6x8", "7x8", "7x16", "Just a car display"] },
            { name: "message", label: "Tell us about your build or business", type: "textarea" },
          ]} />
      </section>
    </div>
  );
}
